import React from 'react';

import ListSubItemText, { ListSubItemTextProps } from '../ListSubItemText';

interface ListSubItemProps {
  subItems: ListSubItemTextProps[];
  className?: string;
}

const ListSubItem: React.FC<ListSubItemProps> = ({ subItems, className }) => {
  return (
    <ul className={className}>
      {subItems.map((subItem, index) => (
        <li key={index}>
          <ListSubItemText text={subItem.text} icon={subItem.icon}/>
        </li>
      ))}
    </ul>
  );
};

export default ListSubItem;
